// extracted by mini-css-extract-plugin
export default {"skipLink":"BPHVVzR TYb4J9A EVhxZk8 leavesden2"};